export default __webpack_public_path__ + "static/media/zz.e8cb4d47.png";